<div class="button-container" *ngIf="isRepeatable">
  <button *ngIf="isDeletable" class="delete-button" (click)="delete($event)">
    <mat-icon>delete_outline</mat-icon>
    <span>Supprimer</span>
  </button>
  <button class="add-button" (click)="add($event)">
    <mat-icon>add</mat-icon>
    <span>{{'eform-editable.sub-section|add' | translate}}</span>
  </button>
</div>
